import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import {
  LoginContainer,
  LoginWrapper,
  IllustrationContainer,
  LogoTopContainer,
  Illustration,
  IllustrationText,
  IllustrationDescription,
  FormContainer,
  Logo,
  FormTitle,
  Label,
  PasswordToggle,
  FormRow,
  ForgotPassword,
  LoginButton,
  OrDivider,
  GoogleLoginButton,
  GoogleIcon,
  RegisterPrompt,
  RegisterCustomerLink,
  ProviderLink,
  LoginTypeToggle,
} from "../../styles/login";
import { Switch, Checkbox, FormControlLabel } from "@mui/material";

import { alertMessage } from "../../services/alertService";
import { ALERT_TITLES } from "../../constants";
// Use a placeholder image until the actual illustration is available
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  LoadingSpinner,
  LoadingOverlay,
  LoadingSpinnerIcon,
} from "../../styles/loading";
import { RememberMeContainer } from "../../styles/login";
import {
  ErrorText,
  FormGroup,
  FullWidthContainer,
  InputField,
  Input,
  PhonePrefix,
  LinkContainer,
} from "../../styles/PersonalInfoStep";
import {
  PatternValidators,
  validPattern,
} from "../../utils/validators";
import AddMobileSocial from "./molecules/AddMobileSocial";
import {
  removeItem,
  setItem,
  setItemWithObject,
} from "../../utils/cache/LocalStorage";
import { POST } from "../../services/HTTPServices";
import { getAuth, signInWithPopup } from "firebase/auth";
import { google } from "../../config/firebase";

import LoginImage from "../../assets/svgs/LoginSignup/Login.svg";
import GoogleImage from "../../assets/svgs/LoginSignup/google.svg";
import LogoImage from "../../assets/svgs/LoginSignup/logo.svg";
import { setUserData } from "../../utils/storage";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = React.useState("");
  const [submitBtnClick, setSubmitBtnClick] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const [checkedRememberMe, setCheckedRememberMe] = React.useState(false);
  const [errors, setErrors] = React.useState<{ [key: string]: boolean }>({
    mobile: true,
    password: true,
  });
  const [values, setValues] = React.useState({
    mobile: "",
    password: "",
    confirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
  });

  const [user, setUser] = React.useState<any>(null);
  const [socialLoginSuccess, setSocialLoginSuccess] =
    React.useState<boolean>(true);

  const [loginType, setLoginType] = React.useState<string>("mobile");

  const [valid, setValid] = React.useState({
    mobile: true,
    password: true,
    confirmPassword: true,
  });
  const handleCopy = (event: any) => {
    event.preventDefault(); // Prevent default copy behavior
  };

  useEffect(() => {
    setValid({
      mobile: true,
      password: true,
      confirmPassword: true,
    })
  }, []);
  

  const toggleLoginType = () => {
    const newType = loginType === "mobile" ? "email" : "mobile";
    setLoginType(newType);
    setValues({ ...values, mobile: "" });
    setItem("loginType", newType);
  };

  const togglePasswordVisibility = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  useEffect(() => {
    setErrorMessage("");
    setSubmitBtnClick(false);

    setLoading(false);
    const login_obj = JSON.parse(
      localStorage.getItem("login_credentials") || "null"
    );

    if (login_obj && login_obj.mobile) {
      setValues(login_obj);
    }
    const loginType = localStorage.getItem("loginType") || "";
    if (loginType && loginType !== "") {
      setLoginType(loginType);
    }
    setErrors({
      mobile: true,
      password: true,
    });
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setValues({ ...values, [name]: value });
    validateField(name, value);
    setErrorMessage("");
  };

  const validateField = async (prop: any, value: any) => {
    let isValid: boolean = true;

    try {
      switch (prop) {
        case "mobile": {
          isValid = await validPattern({
            paramPattern: value,
            patternType: loginType === "mobile" ? "mobile" : "email",
          });
          break;
        }
        case "password": {
          isValid = value.length > 0;
          break;
        }
      }
    } catch (err) {}

    setErrors((prev) => ({
      ...prev,
      [prop]: !isValid, // Invert the error state to match your validation logic
    }));

    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission
    e.stopPropagation(); // Prevent event bubbling

    await setSubmitBtnClick(true);
    const fieldsToValidate = ["mobile", "password"];

    const validationResults = await Promise.all(
      fieldsToValidate.map((field) =>
        validateField(field, values[field as keyof typeof values])
      )
    );

    const hasErrors = validationResults.some((isValid) => !isValid);
    const isFormValid = !hasErrors;

    if (isFormValid) {
      setLoading(true);
      let tempUser = {
        userName: (loginType === "mobile" ? "+65" : "") + values.mobile,
        password: values.password,
      };

      let url = "users/UserLogin";

      let res: any = await POST(url, tempUser, "user");

      if (res && res.status === 200) {
        if (res.data) {
          //setItemWithObject("authUser", res.data);
          setUserData(res.data);
          setItem("send_merchant_auth_token", res.data.token);
          navigate("/dashboard");
        }
        if (checkedRememberMe) setItemWithObject("login_credentials", values);
        else removeItem("login_credentials");
        setLoading(false);
      } else {
        if (res.status && res.status === 401) navigate("/unauthorized-page");
        else if (res.message === "User is not confirmed.") {
          setItemWithObject("user-login-info", {
            userName: values.mobile,
          });
        } else {
          setErrorMessage(res.message);
          alertMessage(ALERT_TITLES.ERROR, res.message);
        }
        setLoading(false);
      }
    }
  };

  const googleLogin = async (provider: any) => {
    const auth = getAuth();
    auth.languageCode = "it";

    await signInWithPopup(auth, provider)
      .then((result: any) => {
        if (result.user.accessToken) {
          setUser(result.user);
          postSocialLogin(result.user.accessToken);
        }

        if (window.opener) {
          window.close();
        }
      })
      .catch((error) => {
        console.error("Google login failed", error);
      });
  };

  const postSocialLogin = async (token: any) => {
    let url = "users/SocialLogin";
    let temp = {
      token: token,
    };

    let res: any = await POST(url, temp, "user");

    if (res && res.status === 200 && res.data) {
      setItemWithObject("authUser", res.data);
      setLoading(false);
    } else {
      setLoading(false);
      if (res.status && res.status === 401) navigate("/unauthorized-page");
      else {
        setSocialLoginSuccess(false);
      }
    }
  };

  // const facebookLogin = async (provider: any) => {
  //   const auth = getAuth();
  //   signInWithPopup(auth, provider)
  //     .then((result: any) => {
  //       setUser(result.user);
  //     })
  //     .catch((error) => {});
  // };

  const isValid = () => {
    if (
      values.mobile === "" ||
      values.password === "" ||
      !valid["mobile"] ||
      !valid["password"]
    )
      return false;
    else return true;
  };

  const rememberMeChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedRememberMe(event.target.checked);
    if (event.target.checked) setItemWithObject("login_credentials", values);
    else {
      removeItem("login_credentials");
      removeItem("loginType");
    }
  };

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}
      <LoginContainer>
        <LoginWrapper>
          <IllustrationContainer>
            <LogoTopContainer>
              <Logo>
                <img src={LogoImage} alt="LogoImage" />
              </Logo>
            </LogoTopContainer>
            <Illustration src={LoginImage} alt="LoginImage" />
            <IllustrationText>
              <IllustrationDescription>
                Shop food, groceries, and services with ease - delivered
                straight to you.
              </IllustrationDescription>
            </IllustrationText>
          </IllustrationContainer>

          {socialLoginSuccess ? (
            <FormContainer>
              <FormTitle>Login to your account</FormTitle>

              <form autoComplete="off">
                <LoginTypeToggle position="right">
                  <FormControlLabel
                    className="m-0"
                    control={
                      <Switch
                        checked={loginType === "email"}
                        onChange={toggleLoginType}
                        color="primary"
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#E39435",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "#E39435",
                            },
                        }}
                        size="small"
                      />
                    }
                    label="Login with Email"
                    labelPlacement="start"
                  />
                </LoginTypeToggle>

                <FormGroup $hasError={!!errors.mobile} className="mb-16">
                  <FullWidthContainer>
                    <Label>
                      {loginType === "mobile" ? "Mobile" : "Email"}*
                    </Label>
                    <InputField $hasError={!!errors.mobile}>
                      {loginType === "mobile" && (
                        <PhonePrefix color="#34A853">+65</PhonePrefix>
                      )}
                      <Input
                        type="text"
                        name="mobile"
                        placeholder={
                          loginType === "mobile"
                            ? "Enter your mobile"
                            : "Enter your email"
                        }
                        value={values.mobile}
                        onChange={handleChange}
                        $hasError={!!errors.mobile}
                        className={
                          loginType === "mobile" ? "ml-16" : "ml-negative-16"
                        }
                        color="#34A853"
                      />
                    </InputField>
                  </FullWidthContainer>
                </FormGroup>

                {submitBtnClick && errors.mobile && (
                  <ErrorText>
                    <PatternValidators
                      paramPattern={values.mobile}
                      patternType={loginType}
                      textType={loginType === "mobile" ? "Mobile" : "Email"}
                    />
                  </ErrorText>
                )}

                {/* Password Field */}
                <FormGroup className="mb-16">
                  <FullWidthContainer>
                    <Label>Password</Label>
                    <InputField $hasError={!!errors.password}>
                      <Input
                        type={values.showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Create a password"
                        value={values.password}
                        onChange={handleChange}
                        onCopy={handleCopy}
                        $hasError={!!errors.password}
                        className="ml-negative-16"
                        autoComplete="new-password"
                        color="#34A853"
                      />
                      <PasswordToggle
                        onClick={togglePasswordVisibility}
                        type="button"
                        className="mt-negative-12"
                      >
                        {values.showPassword ? (
                          <VisibilityOff sx={{ color : "#E39435"}} />
                        ) : (
                          <Visibility sx={{ color : "#E39435"}} />
                        )}
                      </PasswordToggle>
                    </InputField>
                  </FullWidthContainer>
                </FormGroup>
                {submitBtnClick && values.password.length === 0 && (
                  <ErrorText>Password is required</ErrorText>
                )}

                <FormRow>
                  <RememberMeContainer>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkedRememberMe}
                          onChange={rememberMeChanged}
                          className="green-checkbox"
                        />
                      }
                      label="Remember me"
                    />
                  </RememberMeContainer>
                  <ForgotPassword
                    onClick={() => navigate("/forgot-password/email")}
                  >
                    Forgot Password?
                  </ForgotPassword>
                </FormRow>
                {errorMessage && <ErrorText>{errorMessage}</ErrorText>}

                <LoginButton
                  type="submit" // Change to button to prevent form submission
                  disabled={!isValid()}
                  onClick={handleSubmit} // Handle click instead of form submit
                >
                  LOGIN NOW
                </LoginButton>
              </form>

              <OrDivider>or</OrDivider>

              <GoogleLoginButton onClick={() => googleLogin(google)}>
                <GoogleIcon>
                  <img src={GoogleImage} alt="GoogleImage" />
                </GoogleIcon>
                LOGIN WITH GOOGLE
              </GoogleLoginButton>

              <RegisterPrompt>Don&apos;t have an account?</RegisterPrompt>
              <LinkContainer>
                <RegisterCustomerLink
                  to="https://send.com.sg/user-on-boarding"
                  className="mr-8"
                >
                  Register as a Customer
                </RegisterCustomerLink>
                <ProviderLink to="/merchant-registration">
                  Register as a Service Provider
                </ProviderLink>
              </LinkContainer>
            </FormContainer>
          ) : (
            <AddMobileSocial
              token={user.accessToken}
              callback={() => navigate("/web-ecommerce/-1")}
            />
          )}
        </LoginWrapper>
      </LoginContainer>
    </>
  );
};

export default Login;
